<template>
  <div>
    <div style="background-color: red">
      <v-tabs hide-slider background-color="#ECF1F2" v-model="tab">
        <v-tab
          class="tabs-text"
          href="#tab-1"
          :disabled="tab1"
          @click="
            () => {
              this.tab = 'tab-1';
              this.continuebtn = true;
            }
          "
          >Product detail</v-tab
        >
        <v-icon> mdi-chevron-right </v-icon>
        <v-tab
          :disabled="tab2"
          href="#tab-2"
          class="tabs-text"
          @click="
            () => {
              this.tab = 'tab-2';
              this.continuebtn = true;
            }
          "
          >Pricing</v-tab
        >
        <v-icon> mdi-chevron-right </v-icon>
        <v-tab
          :disabled="tab3"
          class="tabs-text"
          href="#tab-3"
          @click="
            () => {
              this.tab = 'tab-3';
              this.continuebtn = true;
            }
          "
          >Shipping</v-tab
        >
        <v-icon> mdi-chevron-right </v-icon>
        <v-tab
          :disabled="tab4"
          class="tabs-text"
          href="#tab-4"
          @click="
            () => {
              this.tab = 'tab-4';
              this.continuebtn = false;
            }
          "
        >
          Publish</v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat class="pa-5">
            <div>
              <span class="mt-2 text-heading"> Product Details </span>
              <v-row class="mt-3">
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Product Name"
                    v-model="$v.formData.ProductName.$model"
                    hide-details=""
                  ></v-text-field>
                  <div class="red--text" v-if="$v.formData.ProductName.$error">
                    Product Name is required
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Category"
                    attach
                    v-model="$v.formData.CategoryId.$model"
                    hide-details=""
                    :items="GetProductCategories"
                    item-value="Category.Id"
                    item-text="Category.CategoryName"
                  ></v-select>
                  <div class="red--text" v-if="$v.formData.CategoryId.$error">
                    Category is required
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    label="Course Prerequisite for purchase"
                    attach
                    v-model="$v.formData.PrerequisiteCourse.$model"
                    hide-details=""
                    :items="courses"
                    item-value="Id"
                    item-text="Title"
                  ></v-select>
                  <div
                    class="red--text"
                    v-if="$v.formData.PrerequisiteCourse.$error"
                  >
                    Prerequisite Course is required
                  </div>
                </v-col>
              </v-row>
              <!-- <v-textarea
                auto-grow
                label="Product Description"
                rows="3"
                row-height="30"
                counter="300"
                hide-details=""
                v-model="$v.formData.ProductDescription.$model"
              ></v-textarea> -->
              <vue-editor
              class="mt-4"
                useCustomImageHandler
                v-model="$v.formData.ProductDescription.$model"
              ></vue-editor>
              <div
                class="red--text"
                v-if="$v.formData.ProductDescription.$error"
              >
                Product Description is required
              </div>
              <v-row class="mt-3">
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Store Display Order"
                    hide-details=""
                    type="number"
                    v-model="$v.formData.DisplayOrder.$model"
                  ></v-text-field>
                  <div class="red--text" v-if="$v.formData.DisplayOrder.$error">
                    Store Display Order is required
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="SKU"
                    type="number"
                    hide-details=""
                    disabled
                    v-model="$v.formData.SKU.$model"
                  ></v-text-field>
                  <div class="red--text" v-if="$v.formData.SKU.$error">
                    SKU is required
                  </div>
                </v-col>
              </v-row>
              <v-select
                auto-grow
                label="Physical / Digital"
                attach
                hide-details=""
                v-model="$v.formData.physical.$model"
                :items="selectitem"
              ></v-select>
              <div class="red--text" v-if="$v.formData.physical.$error">
                Physical / Digital is required
              </div>
              <v-row class="mt-3">
                <span class="mt-5"><b> Weight </b> </span>
                <v-col cols="12" md="6">
                  <!-- Weight in pounds (Ib) -->
                  <v-text-field
                    label="Weight (Ib)"
                    hide-details=""
                    type="number"
                    v-model="$v.formData.Weight.$model"
                  ></v-text-field>
                  <div class="red--text" v-if="$v.formData.Weight.$error">
                    Weight is required
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <!-- Weight in ounces (oz) -->
                  <v-text-field
                    label="Weight (oz)"
                    v-model="$v.formData.Volume.$model"
                    hide-details=""
                    ></v-text-field>
                  <!-- label="Volume (15x24x15 cm)" -->
                  <div class="red--text" v-if="$v.formData.Volume.$error">
                    Volume is required
                  </div>
                </v-col>
              </v-row>
              <div class="d-flex">
                <span class="mt-5"><b> Include book details: </b> </span>
                <v-switch v-model="ToggleOne" class="pl-2">
                  <template v-slot:label>
                    <div v-if="ToggleOne" class="mt-1">Yes</div>
                    <div v-else class="mt-1">No</div>
                  </template>
                </v-switch>
              </div>
              <div v-if="ToggleOne">
                <v-row class="">
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Author"
                      v-model="$v.formData.Author.$model"
                      hide-details=""
                    ></v-text-field>
                    <div class="red--text" v-if="$v.formData.Author.$error">
                      Author is required
                    </div>
                  </v-col>

                  <v-col cols="12" md="6">
                    <!-- <v-text-field label="Publish Date"></v-text-field> -->
                    <div>
                      <v-menu
                        ref="menu"
                        attach
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="formData.PublishDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formData.PublishDate"
                            label="Publish Date"
                            append-icon="mdi-calendar-range-outline"
                            readonly
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formData.PublishDate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(formData.PublishDate)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <div
                        class="red--text"
                        v-if="$v.formData.PublishDate.$error"
                      >
                        PublishDate is required
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Format"
                      hide-details=""
                      v-model="$v.formData.Format.$model"
                    ></v-text-field>
                    <div class="red--text" v-if="$v.formData.Format.$error">
                      Format is required
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Publisher"
                      hide-details=""
                      v-model="$v.formData.Publisher.$model"
                    ></v-text-field>
                    <div class="red--text" v-if="$v.formData.Publisher.$error">
                      Publisher is required
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Edition"
                      hide-details=""
                      v-model="$v.formData.Edition.$model"
                    ></v-text-field>
                    <div class="red--text" v-if="$v.formData.Edition.$error">
                      Edition is required
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Length"
                      hide-details=""
                      type="number"
                      v-model="$v.formData.Length.$model"
                    ></v-text-field>
                    <div class="red--text" v-if="$v.formData.Length.$error">
                      Length is required
                    </div>
                  </v-col>
                </v-row>
                <!-- <v-row class="mt-3">
                  <v-col cols="12" md="6">
                    <v-select
                      label="Discount Members"
                      hide-details=""
                      :items="getMembership"
                      item-text="Name"
                      item-value="Id"
                      multiple
                      v-model="$v.formData.DiscountedMembersBook.$model"
                    ></v-select>
                    <div
                      class="red--text"
                      v-if="$v.formData.DiscountedMembersBook.$error"
                    >
                      Members is required
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Membership Pricing"
                      hide-details=""
                      v-model="$v.formData.MembershipPricingBook.$model"
                    ></v-text-field>
                    <div
                      class="red--text"
                      v-if="$v.formData.MembershipPricingBook.$error"
                    >
                      This is required
                    </div>
                  </v-col>
                </v-row> -->
              </div>
              <div class="pa-15 pt-0 pl-0 pb-0">
                <div class="my-6">
                  <span><b> Images 0/5</b> </span>
                </div>
                <span
                  style="
                    font-size: 13px;
                    font-weight: 500;
                    color: rgba(8, 8, 22, 0.38);
                  "
                >
                  Size Guidelines: Main image should be 600x400px. Secondary
                  images should be 350x300px
                </span>
                <imageuploader-section
                  @SetCoverImage="SetCoverImage"
                  @SetImage1="SetImage1"
                  @SetImage2="SetImage2"
                  @SetImage3="SetImage3"
                  @SetImage4="SetImage4"
                  :storeImage="formData"
                />
                <div class="red--text" v-if="$v.formData.CoverImage.$error">
                  Main images is required
                </div>
                <!-- <div class="red--text" v-if="!validateImages()">
                  All Images are required
                </div> -->
              </div>

              <div class="py-3">
                <span class="h1_tab2"
                  ><b
                    >Related products{{
                      this.GetSelectedRelatedproducts.length
                    }}/4</b
                  ></span
                >
              </div>
              <v-row class="">
                <v-col
                  cols="12"
                  md="4"
                  v-for="(item, index) in GetSelectedRelatedproducts"
                  :key="index"
                >
                  <div>
                    <v-card
                      class=""
                      outlined
                      style="border: 1px solid rgba(8, 8, 22, 0.15)"
                      flat
                      max-width="400px"
                    >
                      <v-img
                        height="200px"
                        :src="
                          imgShow ? imageUrl(item.CoverImage) : item.CoverImage
                        "
                      ></v-img>

                      <v-card
                        class=""
                        rounded="circle"
                        color="white"
                        flat
                        style="position: absolute; top: 5px; right: 0"
                      >
                        <!-- <v-icon
                          close
                          color="primary"
                          @click="RemoveSelectedProduct(item.Id)"
                          >mdi-close</v-icon
                        > -->
                      </v-card>
                      <div class="px-3">
                        <span class="content_span">{{ item.ProductName }}</span>
                        <div class="pb-2">
                          <span class="content_date"
                            >$ {{ item.PublicPrice }}</span
                          >
                        </div>
                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
              <div class="pt-6">
                <v-btn
                  class="px-6 text_style"
                  outlined
                  style="
                    text-transform: none !important;
                    border: 1px solid rgba(8, 8, 22, 0.15);
                    color: rgba(34, 34, 34, 0.7);
                  "
                  @click="Rcontentdialog = true"
                  >Add related product
                </v-btn>
              </div>
            </div>
            <!-- <productdetails /> -->
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card flat class="pa-5">
            <pricing
              ref="pricingChild"
              @SetPrice="SetPrice"
              @SetStartDate="SetStartDate"
              @SetEndDate="SetEndDate"
              @SetDiscount="SetDiscount"
              @SetPercentage="SetPercentage"
              @SetApplyTo="SetApplyTo"
              @SetTaxable="SetTaxable"
              @SetMemberPricing="SetMemberPricing"
              :pricingcomp="formData"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <v-card flat class="pa-5">
            <div>
              <div>
                <span class="mt-2 text-heading"> Shipping </span>
              </div>
              <v-textarea
                v-model="$v.formData.ShippingAddress.$model"
                counter="500"
                value=""
                label="Enter shipping and returns details:"
              ></v-textarea>
              <div class="red--text" v-if="$v.formData.ShippingAddress.$error">
                Shipping Address is required
              </div>
              <!-- <div class="mt-7 mb-15 pb-10">
                <v-card color="#C4C4C4" dark flat outlined class="mb-15">
                  <div class="d-flex justify-center align-center">
                    <span class="pa-15 px-5 text-color-card">
                      We need more info for complete this section
                    </span>
                  </div>
                </v-card>
              </div> -->
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-4">
          <v-card flat class="pa-5">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Initial Stock"
                  v-model="formData.Stock"
                  single-line
                  type="number"
                  :error-messages="
                    $v.formData.Stock.$error
                      ? 'Initial Stock is required'
                      : null
                  "
                >
                </v-text-field>
                <v-select
                  :items="getMembership"
                  label="Display To"
                  item-text="Name"
                  item-value="Id"
                  multiple
                  single-line
                  v-model="formData.DisplayTo"
                  :error-messages="
                    $v.formData.DisplayTo.$error
                      ? 'Display Order is required'
                      : null
                  "
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <publish
                  :price="this.formData"
                  :PreviewImages="this.PreviewImg"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div class="d-flex justify-end mx-5 py-5">
      <v-btn depressed text color="#A1A1A6" class="px-5 pr-5" @click="close()">
        Cancel
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="px-10"
        v-if="continuebtn === true"
        @click="changeTab()"
      >
        Continue
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="px-14 py-2 text_style"
        :disabled="btnloader == true"
        v-if="continuebtn == false"
        @click="send()"
      >
        <span v-if="btnloader != true"> Publish </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
    <v-dialog v-model="Rcontentdialog" max-width="600">
      <v-card>
        <div class="px-9 py-2">
          <div class="my-4">
            <h2>Related content</h2>
          </div>
          <v-row>
            <v-col cols="8" md="12" sm="6">
              <v-card flat>
                <v-text-field
                  dense
                  outlined
                  prepend-inner-icon="mdi-magnify"
                  label="Search"
                  hide-details
                  single-line
                  v-model="search"
                  @input="fetchDataRelatedContent()"
                >
                </v-text-field>
              </v-card>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="GetProductsUpdateInventory"
            hide-default-header
            class="mt-4"
          >
            <template v-slot:[`item.images`]="{ item }">
              <div style="display: flex; align-items: center" class="px-2 pa-2">
                <v-avatar v-if="typeof item.CoverImage == 'string'" tile>
                  <img :src="item.CoverImage" alt="John" />
                </v-avatar>
                <v-avatar tile v-else>
                  <v-icon>mdi-account-off-outline</v-icon>
                </v-avatar>
                <div>
                  <p class="mb-0 mx-3 index-head">
                    {{ item.ProductName }}
                  </p>
                </div>
              </div>
            </template>
            <template v-slot:[`item.date`]="{ item }">
              <div class="my-1">
                <span class="mx-3 date_time_style">{{
                  item.ModifiedDate == null
                    ? new Date().toISOString().split("T")[0]
                    : item.ModifiedDate.split("T")[0]
                }}</span>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-switch
                @change="onChange(item)"
                :input-value="checkIsExist(item.Id)"
                :disabled="
                  GetSelectedRelatedproducts.length >= 4 &&
                  GetSelectedRelatedproducts.find((x) => x.Id === item.Id) ==
                    undefined
                "
              />
            </template>
          </v-data-table>
        </div>
        <v-card-actions class="px-9 pb-9">
          <v-spacer></v-spacer>
          <v-btn
            color="#A1A3A8"
            class="text_style mx-3"
            outlined
            @click="relatedContentDialogClose()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            depressed
            class="px-14 text_style"
            @click="relatedContentDialogClose()"
          >
            <!-- @click="RelatedContentSend()" -->
            <v-progress-circular
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Pricing from "./pricing.vue";
//import CameraBorderBoxSvg from "../../assets/SvgIcons/CameraborderboxSvg.vue";
import Publish from "./publish.vue";
//import Shiping from "./shipping.vue";
import ImageuploaderSection from "./imageuploaderSection.vue";
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  name: "",
  props: ["editData", "imgShow"],
  components: { Pricing, Publish, ImageuploaderSection,VueEditor },
  data() {
    return {
      Rcontentdialog: false,
      isEditMode: false,
      date: "",
      ToggleOne: false,
      menu: false,
      btnloader: false,
      search: "",
      continuebtn: true,
      filtersArray: [],
      tab: "tab-1",
      selectitem: ["Physical", "Digital"],
      displayitems: ["Appetizers", "Entrees", "Deserts", "Cocktails"],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      relatedContentArray: [
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
      PreviewImg: {
        showCoverImageInPreview: "",
      },

      headers: [
        { text: "", value: "images" },
        { text: "", value: "date" },
        { text: "", value: "actions", sortable: false },
        {
          text: "",
          value: "",
          sort: function (a, b) {
            if (a ^ b) {
              return a && !b ? -1 : 1;
            } else {
              return 0;
            }
          },
        },
      ],
      courses: [],
      tab3: true,
      tab2: true,
      tab4: true,
      tab1: false,
      formData: {
        Id: 0,
        ProductName: "",
        CategoryId: "",
        PrerequisiteCourse: "",
        ProductDescription: "",
        DisplayOrder: "",
        SKU: "",
        Author: "",
        Volume: "",
        Weight: "",
        physical: "",
        Format: "",
        Publisher: "",
        Edition: "",
        PublishDate: "",
        Length: "",
        Image1: "",
        Image2: "",
        Image3: "",
        Image4: "",
        CoverImage: "",
        ShippingAddress: "As a small business with limited inventory, all sales are final. For shipment errors or damaged products, please contact us at office@bodytalksystem.com. Shipments from the US to other countries or overseas may face delays. Use the tracking link in your order email for updates. For delays and issues, please contact the carrier directly.",
        DisplayTo: "",
        RelatedProductIds: "",
        DiscountMembers: "",
        DiscountedMembersBook: "",
        MembershipPricingBook: 0,
        MembershipPricing: [],
        Stock: "",
        PublicPrice: "",
        percentage: "",
        applyto: "",
        DiscountPercentage: "",
        StartTime: "",
        EndTime: "",
        Discounted: false,
        Istaxable: false,
      },
    };
  },
  validations: {
    formData: {
      ProductName: { required },
      CategoryId: { required },
      PrerequisiteCourse: { required },
      ProductDescription: { required },
      DisplayOrder: { required },
      SKU: { required },
      physical: { required },
      Weight: { required },
      Volume: { required },
      Author: { required },
      Format: { required },
      Publisher: { required },
      PublishDate: { required },
      Edition: { required },
      Length: { required },
      shippng: { required },
      ShippingAddress: { required },
      CoverImage: { required },
      Image1: { required },
      Image2: { required },
      Image3: { required },
      Image4: { required },
      DisplayTo: { required },
      RelatedProductIds: { required },
      DiscountedMembersBook: { required },
      MembershipPricingBook: { required },
      DiscountPercentage: { required },
      StartTime: { required },
      EndTime: { required },
      Stock: { required },
      PublicPrice: { required },
    },
  },
  mounted() {
    this.fetchDataRelatedContent();
    // this.fetchData();
    this.formData.SKU = this.generateUniqueRandom();
    var obj = {
      search: "",
      page: 1,
      pageSize: "All",
      filters: JSON.stringify(this.filtersArray),
    };
    if (this.editData) {
      this.isEditMode = true;
      this.formData.Id = this.editData.Id;
      this.formData = this.editData;
      if (!this.formData.CoverImage) {
        this.formData.CoverImage = require('../../assets/images/default-img2.jpg');
        this.PreviewImg.showCoverImageInPreview = this.formData.CoverImage;
      } else {
        this.PreviewImg.showCoverImageInPreview = this.imageUrl(this.formData.CoverImage);
      }
      this.formData.ShippingAddress = "As a small business with limited inventory, all sales are final. For shipment errors or damaged products, please contact us at office@bodytalksystem.com. Shipments from the US to other countries or overseas may face delays. Use the tracking link in your order email for updates. For delays and issues, please contact the carrier directly."
      // this.formData.displayorder = this.editData.DisplayOrder;
      this.formData.physical = this.editData.IsPhysical
        ? "Physical"
        : "Digital";
      // this.formData.Weight = this.editData.Weight;
      this.formData.PublishDate = this.editData.PublishDate?.split("T")[0];
      this.formData.Format = this.editData.Format;
      this.formData.Publisher = this.editData.Publisher;
      this.formData.Edition = this.editData.Edition;
      this.formData.Length = this.editData.Length;
      this.formData.PrerequisiteCourse = this.editData.PrerequisiteCourse;
      this.formData.DiscountedMembersBook =
        this.editData.DiscountedMembersBook != null
          ? this.editData.DiscountedMembersBook.split(",")
          : [];
      let displayToArray = this.editData.DisplayTo.split(",");
      this.formData.DisplayTo = displayToArray.map((str) => Number(str));
      this.editData.RelatedProducts?.forEach((x) => {
        console.log(x.RelatedProduct);
        this.$store.dispatch("SetRelatedProducts", x.RelatedProduct);
      });
      console.log(this.formData.MemberPricing);
      if (
        this.editData.MemberPricing != undefined &&
        this.editData.MemberPricing.length > 0
      ) {
        this.formData.MembershipPricing = this.editData.MemberPricing;
      }
      this.ToggleOne = this.editData.IncludeBookDetails;
    }
    obj.pageSize = "all";
    this.$store.dispatch("GetCourse", obj).then(() => {
      this.courses.push({ Id: 0, Title: "None" });
      this.courses = [...this.courses, ...this.GetCourses];
    });
    this.$store.dispatch("getMembership");
  },
  computed: {
    ...mapGetters([
      "GetProductCategories",
      "GetCourses",
      "GetProducts",
      "GetSelectedRelatedproducts",
      "getMembership",
      "GetLoggedInUser",
      "GetProductsUpdateInventory",
    ]),
  },
  methods: {
    generateUniqueRandom() {
      const timestamp = Date.now();
      const randomNumber = Math.floor(Math.random() * 1000);
      const uniqueNumber = timestamp * 1000 + randomNumber;
      return uniqueNumber.toString().slice(7);
    },
    fetchData() {
      const obj = {
        search: this.search,
        page: 1,
        pageSize: this.search,
        filters: "",
      };
      this.$store.dispatch("GetProducts", obj);
    },
    relatedContentDialogClose() {
      this.search = "";
      this.fetchDataRelatedContent();
      this.Rcontentdialog = false;
    },
    fetchDataRelatedContent() {
      const obj = {
        search: this.search,
        page: 1,
        pageSize: "All",
        filters: "",
      };
      this.$store.dispatch("GetProductsUpdateInventory", obj);
    },
    SetMemberPricing(m) {
      this.formData.MembershipPricing = m;
      console.log(this.formData.MembershipPricing);
    },
    onChange(obj) {
      this.imgShow = false;
      this.$store.dispatch("SetRelatedProducts", obj);
    },
    checkIsExist(id) {
      return this.GetSelectedRelatedproducts.some((x) => x.Id === id);
    },
    RemoveSelectedProduct(id) {
      this.$store.dispatch("RemoveSelectedProduct", id);
    },
    imageUrl(data) {
      // return process.env.VUE_APP_IMG_URL + data;
      return data;
    },
    close(index) {
      this.$emit("close");
      this.relatedContentArray.splice(
        this.relatedContentArray.indexOf(index),
        1
      );
      this.$store.dispatch("RemoveSelectedProduct", "cancel");
    },
    SetPrice(p) {
      this.formData.PublicPrice = p;
    },
    SetStartDate(p) {
      this.formData.StartTime = p;
    },
    SetEndDate(p) {
      this.formData.EndTime = p;
    },
    SetDiscount(d) {
      this.formData.Discounted = d;
    },
    SetPercentage(p) {
      this.formData.DiscountPercentage = p;
    },
    SetApplyTo(m) {
      this.formData.DiscountMembers = m;
    },
    SetTaxable(t) {
      this.formData.Istaxable = t;
    },
    send() {
      this.$v.formData.DisplayTo.$touch();
      this.$v.formData.Stock.$touch();
      if (
        this.$v.formData.DisplayTo.$invalid ||
        this.$v.formData.Stock.$invalid
      ) {
        return;
      }
      this.btnloader = true;
      //let pricing = this.$refs.pricingChild;
      this.$v.$touch();
      //pricing.check();
      // if (pricing != undefined && pricing.$v.$invalid()) {
      //   return;
      // }
      console.log("formData", this.$v.$pending);
      if (!this.$v.$touch()) {
        var relatedIds = [];
        this.GetSelectedRelatedproducts?.forEach((x) => {
          relatedIds.push(x.Id);
        });
        var Form = new FormData();
        Form.append("ProductName", this.formData.ProductName);
        Form.append("CategoryId", this.formData.CategoryId);
        Form.append("PrerequisiteCourse", this.formData.PrerequisiteCourse);
        Form.append("ProductDescription", this.formData.ProductDescription);

        Form.append("displayorder", this.formData.DisplayOrder);
        if(typeof this.formData.Image1 == "string"){
          Form.append("ImagePath1", this.formData.Image1 || '');
        }else{
          Form.append("Image1", this.formData.Image1 || '');
        }
        if(typeof this.formData.Image2 == "string"){
          Form.append("ImagePath2", this.formData.Image2 || '');
        }else{
          Form.append("Image2", this.formData.Image2 || '');
        }
        if(typeof this.formData.Image3 == "string"){
          Form.append("ImagePath3", this.formData.Image3 || '');
        }else{
          Form.append("Image3", this.formData.Image3 || '');
        }
        if(typeof this.formData.Image4 == "string"){
          Form.append("ImagePath4", this.formData.Image4 || '');
        }else{
          Form.append("Image4", this.formData.Image4 || '');
        }
        Form.append("CoverImage", this.formData.CoverImage);
        Form.append("IncludeBookDetails", this.ToggleOne);
        Form.append("DisplayTo", this.formData.DisplayTo.toString());
        Form.append("DiscountMembers", this.formData.DiscountMembers);
        Form.append("SKU", Number(this.formData.SKU));
        Form.append("Volume", this.formData.Volume);
        Form.append(
          "StartTime",
          this.formData.Discounted == false ? "" : this.formData.StartTime
        );
        Form.append(
          "EndTime",
          this.formData.Discounted == false ? "" : this.formData.EndTime
        );
        if (this.ToggleOne) {
          Form.append("Author", this.formData.Author);
          Form.append("Format", this.formData.Format);
          Form.append("Publisher", this.formData.Publisher);
          Form.append("Edition", this.formData.Edition);
          Form.append("Length", this.formData.Length);
          Form.append(
            "DiscountedMembersBook",
            this.formData.DiscountedMembersBook.toString()
          );
          Form.append("MembershipPricingBook", 0);
          Form.append("PublishDate", this.formData.PublishDate || "");
        }
        Form.append("ShippingAddress", this.formData.ShippingAddress);
        this.formData.MembershipPricing?.forEach((x, i) => {
          Form.append(`MembershipPricing[${i}].MemberId`, x.MemberId);
          Form.append(`MembershipPricing[${i}].Price`, x.Price);
        });
        Form.append("RelatedProductIds", relatedIds.toString());
        Form.append("Stock", this.formData.Stock);
        Form.append("PublicPrice", this.formData.PublicPrice);
        Form.append(
          "DiscountPercentage",
          this.formData.Discounted == false
            ? ""
            : this.formData.DiscountPercentage
        );
        Form.append("Discounted", this.formData.Discounted);
        Form.append("Istaxable", this.formData.Istaxable);
        Form.append("Weight", this.formData.Weight);
        Form.append("UserId", this.GetLoggedInUser.Id);
        Form.append(
          "IsPhysical",
          this.formData.physical == "Physical" ? true : false
        );
        if (this.formData.Id == 0) {
          this.formData.SKU = `PROD_${new Date().getTime()}`;
          this.$store.dispatch("AddStoreProduct", Form).then((res) => {
            if (res.Status) {
              this.$emit("close");
              this.SuccessToast = true;
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Add successfully",
                showConfirmButton: false,
                timer: 1500,
              });
              // this.close();
              setTimeout(() => {
                this.$router.push("/store");
              }, 1200);
            } else {
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        } else {
          Form.append("Id", this.formData.Id);
          this.$store.dispatch("EditStoreProduct", Form).then((res) => {
            this.$store.dispatch("selectRelatedCoureseEmpty", []);
            if (res.Status) {
              this.$emit("close");
              this.SuccessToast = true;
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Edit successfully",
                showConfirmButton: false,
                timer: 1500,
              });
              setTimeout(() => {
                this.$router.push("/store");
              }, 1200);
            } else {
              this.close();
              this.btnloader = false;
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      }
    },
    handleChildData(data) {
      this.receivedData = data;
    },
    validateImages() {
      const { CoverImage, Image1, Image2, Image3, Image4 } = this.formData;
      if (!CoverImage || !Image1 || !Image2 || !Image3 || !Image4) {
        return false;
      }

      return true;
    },
    // changeTab() {
    //   const childComponent = this.$refs.pricingChild;
    //   if (this.tab == "tab-2") {
    //     childComponent.$v.$touch();
    //     this.$v.$touch();
    //     if (!this.$v.formData.$invalid) {
    //       console.log("If part", this.formData);
    //       return;
    //     } else {
    //       console.log("else part", this.formData);
    //       this.tab = "tab-3";
    //       this.continuebtn = true;
    //     }
    //   }
    //   if (this.tab == "tab-1") {
    //     this.$v.$touch();
    //     if (this.$v.formData.$invalid) {
    //       this.tab = "tab-2";
    //       this.continuebtn = true;
    //     } else {
    //       // var objdata = {
    //       //   ProductName: this.formData.ProductName,
    //       //   CategoryId: this.formData.CategoryId,
    //       //   ProductDescription: this.formData.ProductDescription,
    //       //   displayorder: this.formData.displayorder,
    //       //   SKU: this.formData.SKU,
    //       //   physical: this.formData.physical,
    //       //   weight: this.formData.weight,
    //       //   Volume: this.formData.Volume,
    //       //   author: this.formData.author,
    //       //   formate: this.formData.formate,
    //       //   publisher: this.formData.publisher,
    //       //   edition: this.formData.edition,
    //       //   length: this.formData.length,
    //       //   CoverImage: this.formData.CoverImage,
    //       //   Image4: this.formData.Image4,
    //       //   DiscountMembers: this.formData.DiscountMembers,
    //       //   RelatedProductIds: this.formData.RelatedProductIds,
    //       // };
    //       // console.log(objdata);
    //       // this.tab = "tab-2";
    //     }
    //   } else if (this.tab == "tab-3") {
    //     this.$v.formData.ShippingAddress.$touch();
    //     if (this.$v.formData.ShippingAddress.$invalid) {
    //       this.submitStatus = "ERROR";
    //     } else {
    //       var data = {
    //         ShippingAddress: this.formData.ShippingAddress,
    //       };
    //       console.log(data, "this is else call");
    //       this.tab = "tab-4";
    //       this.continuebtn = false;
    //     }
    //   } else {
    //     //this.tab = "tab-3";
    //     this.continuebtn = false;
    //     this.$v.formData.displayto.$touch();
    //     if (this.$v.formData.displayto.$invalid) {
    //       this.submitStatus = "ERROR";
    //     }
    //     //  else {
    //     //   // var datashipp = {
    //     //   //   displayto: this.formData.displayto,
    //     //   // };
    //     //   // console.log(datashipp, "this is else call");
    //     // }
    //     //this.continuebtn = false;
    //   }
    // },

    changeTab() {
      const childComponent = this.$refs.pricingChild;
      if (this.tab === "tab-1") {
        this.$v.formData.ProductName.$touch();
        this.$v.formData.CategoryId.$touch();
        this.$v.formData.PrerequisiteCourse.$touch();
        this.$v.formData.ProductDescription.$touch();
        this.$v.formData.DisplayOrder.$touch();
        this.$v.formData.SKU.$touch();
        this.$v.formData.physical.$touch();
        this.$v.formData.Weight.$touch();
        this.$v.formData.Volume.$touch();
        this.$v.formData.CoverImage.$touch();

        // Check if ToggleOne is true
        if (this.ToggleOne) {
          this.$v.formData.Author.$touch();
          this.$v.formData.Format.$touch();
          this.$v.formData.Publisher.$touch();
          this.$v.formData.Edition.$touch();
          this.$v.formData.Length.$touch();
          this.$v.formData.PublishDate.$touch();
        }

        // Check if any of the fields are invalid
        if (
          this.$v.formData.ProductName.$invalid ||
          this.$v.formData.CategoryId.$invalid ||
          this.$v.formData.PrerequisiteCourse.$invalid ||
          this.$v.formData.ProductDescription.$invalid ||
          this.$v.formData.DisplayOrder.$invalid ||
          this.$v.formData.SKU.$invalid ||
          this.$v.formData.physical.$invalid ||
          this.$v.formData.Weight.$invalid ||
          this.$v.formData.Volume.$invalid ||
        this.$v.formData.CoverImage.$invalid ||
          (this.ToggleOne &&
            (this.$v.formData.Author.$invalid ||
              this.$v.formData.Format.$invalid ||
              this.$v.formData.Publisher.$invalid ||
              this.$v.formData.Edition.$invalid ||
              this.$v.formData.Length.$invalid ||
              this.$v.formData.PublishDate.$invalid))
        ) {
          this.submitStatus = "ERROR";
          return;
        } else {
          // If validation passes, proceed to next tab
          this.tab = "tab-2";
          this.tab2 = false;
          // this.tab1 = true;
          this.continuebtn = true;
        }
      } else if (this.tab == "tab-2") {
        childComponent.$v.formData.price.$touch();
        if (this.formData.Discounted == true) {
          childComponent.$v.formData.DiscountPercentage.$touch();
          childComponent.$v.formData.StartTime.$touch();
          childComponent.$v.formData.EndTime.$touch();
        }
        if (childComponent.$v.formData.price.$invalid) {
          return;
        }
        if (this.formData.Discounted == true) {
          if (
            childComponent.$v.formData.StartTime.$invalid ||
            childComponent.$v.formData.EndTime.$invalid ||
            childComponent.$v.formData.DiscountPercentage.$invalid
          ) {
            return;
          } else {
            this.tab = "tab-3";
            this.tab3 = false;
            // this.tab2 = true;
            this.continuebtn = true;
          }
        } else {
          this.tab = "tab-3";
          this.tab3 = false;
          // this.tab2 = true;
          this.continuebtn = true;
        }
      } else if (this.tab == "tab-3") {
        console.log("hamza");
        this.$v.formData.ShippingAddress.$touch();
        if (this.$v.formData.ShippingAddress.$invalid) {
          this.submitStatus = "ERROR";
          return;
        } else {
          this.tab = "tab-4";
          this.tab4 = false;
          // this.tab3 = true;
          this.continuebtn = false;
        }
      } else if (this.tab == "tab-4") {
        this.$v.formData.DisplayTo.$touch();
        this.$v.formData.Stock.$touch();
        if (
          this.$v.formData.DisplayTo.$invalid ||
          this.$v.formData.Stock.$invalid
        ) {
          this.submitStatus = "ERROR";
          return;
        } else {
          this.continuebtn = false;
        }
      }
    },
    SetCoverImage(CoverImage) {
      this.formData.CoverImage = CoverImage.file;
      this.PreviewImg.showCoverImageInPreview = CoverImage.base64;
    },
    SetImage1(Image1) {
      this.formData.Image1 = Image1.file;
      this.PreviewImg.showImg1InPreview = Image1.base64;
    },
    SetImage2(Image2) {
      this.formData.Image2 = Image2.file;
      this.PreviewImg.showImg2InPreview = Image2.base64;
    },
    SetImage3(Image3) {
      this.formData.Image3 = Image3.file;
      this.PreviewImg.showImg3InPreview = Image3.base64;
    },
    SetImage4(Image4) {
      this.formData.Image4 = Image4.file;
      this.PreviewImg.showImg4InPreview = Image4.base64;
    },
  },
};
</script>

<style scoped>
.red--text {
  color: red;
  font-size: 14px;
}

.tabs-text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  text-transform: none;
}

.text-heading {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}

.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}
.text-heading {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.text-color-card {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #91460e;
}
</style>
